import { Optional } from '@/generic/functional';

export const RULE_IMPORT = Symbol('RULE_IMPORT');

export type Authority = typeof RULE_IMPORT;

const AUTHORITIES = new Map<string, Authority>([['RULE_IMPORT', RULE_IMPORT]]);

export const authorityOf = (key: string): Optional<Authority> =>
  Optional.ofUndefinable(AUTHORITIES.get(key));
